import { Typography } from "@mui/material";
import { IComplaintsResponse } from "interfaces/IComplaints";
import { SummaryItem, Container } from "./styles";


interface GroupSummaryProps {
  group: IComplaintsResponse;
  isMobile?: boolean;
}

export const GroupSummary = ({ group, isMobile = false }: GroupSummaryProps) => {
  return (
    <Container isMobile={isMobile}>
      <SummaryItem>
        <Typography variant="body2" color="text.secondary">
          Total de Quebras (Em pedidos)
        </Typography>
        <Typography variant="h6" fontSize={15}>
          {`${group.totalComplaintsByOrder} (${group.complaintRate}%)`}
        </Typography>
      </SummaryItem>
      <SummaryItem>
        <Typography variant="body2" color="text.secondary">
          Não Entregues
        </Typography>
        <Typography variant="h6" fontSize={15}>
          {group.notDeliveredCount}
        </Typography>
      </SummaryItem>
      <SummaryItem>
        <Typography variant="body2" color="text.secondary">
          Amassados/Quebrados
        </Typography>
        <Typography variant="h6" fontSize={15}>
          {group.damagedCount}
        </Typography>
      </SummaryItem>
      <SummaryItem>
        <Typography variant="body2" color="text.secondary">
          Entregas Erradas
        </Typography>
        <Typography variant="h6" fontSize={15}>
          {group.wrongDeliveryCount}
        </Typography>
      </SummaryItem>
    </Container>
  );
};
